module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"New registration form":"Neues Anmeldeformular","Show filters":"Filter anzeigen","Hide filters":"Filter verbergen","Registration form list could not be fetched.":"Liste der Anmeldeformulare konnte nicht abgerufen werden."}}')
  delete Component.options._Ctor
}
